import React from 'react';
import * as constant from './constants';
import Button from './../Button';
import ImageButton from './../Button/ImageButton';
import FormGroup from './../FormGroup';
import Keyboard from './../Keyboard/Keyboard';
import Asset from "../../requests/apa/Asset";
import Translator from '../../requests/apa/Translator';
import UtilsProfile from '../../utils/Profile';

export const Edit = ({ props }) => { 
  const inputName = 'firstName';
  const inputImage = 'userImage';
  let inputNameField = UtilsProfile.getField(props.fields, inputName);
  let inputImageField = UtilsProfile.getField(props.fields, inputImage);

  if (props.defaultFocus) {
    UtilsProfile.setFocus('.container.edit_profile .row.input .focusable');
  }

  return (
    <div className='container edit_profile'>
      <div className='col left'>
        <div className='row'></div>
        <div className='row keyboard'>
          <Keyboard currentValue={inputNameField.value}
            onClick={(text) => {
              props.setTextValue(text);
            }}/>
        </div>
      </div>
      <div className='col right'>
        <div className='row'></div>
        <div className='row title'>
          <span>{Translator.get('update_profile_title', 'Modificar perfil')}</span>
        </div>
        <div className='row avatar-option'>
          <ImageButton order={['text']} className='image' imgSrc={inputImageField.value}
            focusable={false}
          />
          <Button order={['text']} className='button' text={Translator.get('change_profile_picture_btn', 'Modificar perfil')}
            onClick={() => {
              props.sendMetricProfile({
                event: constant.METRIC_EVENT,
                category: constant.METRIC_CATEGORY_START,
                action: constant.METRIC_ACTION_PROFILE,
                label: constant.METRIC_LABEL_CHANGEIMAGE,
              });
              props.onSetAction(constant.SELECT_PROFILE)
            }} />
        </div>
        <div className='row error'>
          <span className='error'>{inputImageField.error}</span>
        </div>
        <div className='row input'>
          <FormGroup
            id={inputName}
            value={inputNameField.value}
            error={inputNameField.hasError}
            message={inputNameField.error}
            placeholder={Translator.get('enter_profile_name_placeholder', 'Ingresa Nombre')}
            onFocused={() => {
              //setCurrentKey(inputName);
            }} />
        </div>
        <div className='row delete'>
          <Button order={['text']} className='button' text={Translator.get('delete_profile_btn', 'Eliminar perfil')}
            onClick={() => {
              props.sendMetricProfile({
                event: constant.METRIC_EVENT,
                category: constant.METRIC_CATEGORY_START,
                action: constant.METRIC_ACTION_PROFILE,
                label: constant.METRIC_LABEL_DELETEPROFILE,
              });
              props.showWarning(props.data);
            }} />
        </div>
        <div className='row button'>
          <Button order={['text']} className='button' text={Translator.get('cancel_update_profile_btn', 'Cancelar')}
            onClick={() => {              
              props.onSetAction(constant.ADMIN_PROFILE)
            }} />
          <Button order={['text']} className='button' text={Translator.get('update_profile_btn', 'Aceptar')}
            onClick={() => {              
              if (UtilsProfile.validateForm(props.fields, props.onFieldError)) {
                
                props.updateProfile({
                  username: inputNameField.value,
                  user_image: inputImageField.value,
                  gamification_id: props.data && props.data.gamification_id,

                });
                //props.onSetAction(constant.START)
              }
            }} />
        </div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/Profile/Edit.jsx